import GetTheAppPopup from 'components/GetTheAppPopup';
import useModalsStore from 'stores/modalsStore';

const ModalContainer = () => {
  const { isOpen, description, stores, title, toggleQrModal } = useModalsStore(x => ({
    ...x?.qrModal?.qrModal,
    isOpen: x?.qrModal?.isOpen,
    toggleQrModal: x?.toggleQrModal,
  }));

  return (
    <>
      {isOpen ? (
        <GetTheAppPopup
          description={description}
          isPopupOpen={isOpen}
          closeHandler={() => toggleQrModal({ isOpen: false })}
          stores={stores}
          title={title}
        />
      ) : null}
    </>
  );
};

export default ModalContainer;
